import EmployeeList from 'settings/clientRoles/EmployeeList'
import List from 'settings/clientRoles/List'
import Edit from 'settings/clientRoles/Edit'
export default {EmployeeList, List, Edit}
